<template>
  <div class="overdue-banner">
    <div class="title">您已逾期，请尽快还款（元）</div>
    <div class="amount text-primary">{{ amount }}</div>
    <img class="tip-image" src="./images/tips@2x.png">
    <nd-button class="repay-button" @click="repayAction">立即还款</nd-button>
    <div class="tip">今天系统或将进行扣款，<span class="text-primary" @click="checkAccount">查看扣款账户></span></div>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    repayAction () {
      this.$emit('onRepay')
    },
    checkAccount () {
      this.$emit('onCheckAccount')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.overdue-banner {
  width: 670px;
  padding: 56px 30px 30px 30px;
  background: #FFF;
  box-shadow: 0px 30px 20px 0px rgba(211,211,211,0.5);
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  text-align: center;
  border-radius: 20px;
  margin: 0 auto;
  .title {
    font-size: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .amount {
    font-size: 80px;
    font-family: DIN-Medium, DIN;
    font-weight: 500;
    line-height: 97px;
  }
  .tip-image {
    width: 530px;
    height: 56px;
    margin-top: -13px;
  }
  .repay-button {
    width: 570px;
    height: 88px;
    margin: 0 auto;
    margin-top: 15px;
  }
  .tip {
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
    margin-top: 20px;
  }

  .text-primary {
    color: #FF4633;
  }
}
</style>